import React,{useState, useEffect} from 'react';
import "./SearchScreen.css";
import { filterPosts, getDetails } from '../../Utils/Utils';
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaHome , FaBorderAll , FaUsersCog , FaBoxes, FaImage, FaSearch, FaMapMarkerAlt, FaCalendarAlt, FaTag } from "react-icons/fa";
import InterestModal from '../InterestModal/InterestModal';
import { useSelector } from 'react-redux';
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../../Utils/corporateVerification.js";
import { apiUrl } from '../../config/api.js';
import { devLog } from '../../config/devLog.js';
import InArticleAd from '../../Utils/AdUnits/InArticleAd';
import InFeedAd from '../../Utils/AdUnits/InFeedAd';


function SearchScreen() {
    
    const [filteredData, setFilteredData] = useState([]);
    const [allResults, setAllResults] = useState([]);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState("0");
    const [selectedImage, setSelectedImage] = useState("");
    const [images, setImages] = useState([]);
    const [postDetail, setPostDetail] = useState({})
    const [loading, setLoading] = useState(true);
    const [searchedValue, setSearchedValue] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [showModal, setShowModal] = useState(false);

      const { userDetails } = useSelector((state) => state.userReducer);
      const [isModalOpen, setIsModalOpen] = useState(false);

    const openInterestFlow = () => {
      if (!isCorporateVerified(userDetails)) {
        navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
        return;
      }
      setShowModal(true);
    };
    
    
    const updateSelectedCategory = (category)=>{
      devLog('filtered data',filteredData)
      devLog('filtered data',allResults)
      devLog('filtered data',category)

      setSelectedCategory(category);
      let filterData = []
      if(category === "0" || category === 0){
        setFilteredData(allResults);
        return "";
      }
      const categoryNum = parseInt(category);
      allResults.forEach((result)=>{
        if(result.category === categoryNum){
          filterData.push(result)
        }
      })
      setFilteredData(filterData);

    }

    
  useEffect(() => {
    const search = searchParams.get("query");
    if(search !== searchedValue && search !== null){
      devLog(search)
      setSearchQuery(search || "");
      getSearchResults(search);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

      const getSearchResults = async (search) =>{
         setSearchedValue(search)
    const res = await fetch(
      apiUrl("getSearchResults?" + encodeURIComponent(search ?? ""))
    );
    const postResults = await res.json();
    devLog("result", postResults)
    let filteredResults = await filterPosts(postResults)
    devLog(filteredResults)
    
    setAllResults(filteredResults)
    // if(selectedCategory==="0"){
      setFilteredData(filteredResults)
      if(filteredResults.length>0){
      getPost(filteredResults[0].id)
      }
    // }
    // else{
    //   const newData = filteredResults.filter(post=>
    //     post.category == parseInt(selectedCategory))
    //   setFilteredData(newData)
    // }
      }
  

    useEffect(()=>{
        const search = searchParams.get("query");
        devLog(search);
        setSearchQuery(search || "");
        getSearchResults(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    const getPost = async (id) =>{
    if(!id){
      return ;
    }
    setLoading(true)
    setSelectedId(id);
    let response = await fetch(apiUrl("getListings?"+id))
    const postResponse = await response.json();
    devLog("response",postResponse)
    setPostDetail(postResponse[0]);
    const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          setIsModalOpen(true);
        }
    // setSelectedPostId(postResponse[0].id)
    setSelectedImage(postResponse[0]?.image_url?.split(",")[0])
    if(postResponse[0]?.image_url.length>0){
      setImages(postResponse[0]?.image_url?.split(","))
    }
    else{
      setSelectedImage("https://corporatenridata.s3.us-west-1.amazonaws.com/professional_collage_variation.jpg")
      setImages(["https://corporatenridata.s3.us-west-1.amazonaws.com/professional_collage_variation.jpg"])
    }
    setLoading(false)
  }



    // PostDetail Component
    const PostDetail = ({ post }) => {
      if (loading) {
        return (
          <div className="loader-right">
            <div className="skeleton image-thumb" style={{height:"250px", width:"100%"}}></div>
            <div className="skeleton image-thumb" style={{height:"120px", width:"200px", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"250px", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
            <div className="skeleton image-thumb" style={{height:"25px", width:"80%", marginTop:"25px"}}></div>
          </div>
        );
      }

      if (!post || !post.id) {
        return (
          <div className="no-selection">
            <FaImage />
            <h3>No Post Selected</h3>
            <p>Select a post from the list to view details</p>
          </div>
        );
      }

      const postDetails = getDetails(post);

      return (
        <div className="post-detail-container">
          <div className="post-detail-header">
            <div className="post-avatar">
              {post.image_url ? (
                <img src={post.image_url.split(",")[0]} alt="Post" />
              ) : (
                <FaImage className="avatar-placeholder" />
              )}
            </div>
            <div className="post-details">
              <h3>{postDetails?.Title || post.title || "No Title"}</h3>
              <p>Posted by {post.first_name + " " + post.last_name || "Unknown"}</p>
            </div>
            <div className="post-actions">
              <button className="action-btn primary" onClick={openInterestFlow}>
                Show Interest
              </button>
            </div>
          </div>
          <div className="post-detail-content">
            <div className="image-gallery">
              <div className="main-image-container">
                <img src={selectedImage} alt="Selected" className="main-image" />
              </div>
              <div className="thumbnail-container">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`Thumbnail ${index}`}
                    className={`thumbnail ${selectedImage === img ? "selected" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="post-details-grid">
              <h4>Post Details</h4>
              {postDetails &&
                Object.entries(postDetails).map(([key, value], index) =>
                  key !== "Utilities" ? (
                    <div key={index} className="detail-item">
                      <span className="detail-label">{key}</span>
                      <span className="detail-value">{value || "N/A"}</span>
                    </div>
                  ) : null
                )}
              {Array.isArray(postDetails?.Utilities) && postDetails.Utilities.length > 0 && (
                <>
                  <h4>Utilities</h4>
                  {postDetails.Utilities.map((utility) => (
                    <div key={utility.id ?? utility.name} className="post-card">
                      <div className="post-content">
                        <div className="post-title-container">
                          <div className="post-title">{utility.name}</div>
                          <div className="post-price">${utility.price}</div>
                        </div>
                        <div className="post-actions">
                          <div className="post-location">
                            <FaMapMarkerAlt />
                            {utility.storeLink ? (
                              <a href={utility.storeLink} target="_blank" rel="noopener noreferrer">
                                Store Link
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </div>
                          <div className="post-category">
                            <FaTag />
                            {utility.availabilityStatus}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {/* Fallback if no details from getDetails */}
              {(!postDetails || Object.keys(postDetails).length === 0) && (
                <>
                  <div className="detail-item">
                    <span className="detail-label">Title</span>
                    <span className="detail-value">{post.title || "N/A"}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Price</span>
                    <span className="detail-value">{post.price ? `$${post.price}` : "N/A"}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Location</span>
                    <span className="detail-value">{post.location || "N/A"}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Category</span>
                    <span className="detail-value">{post.category || "N/A"}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Posted By</span>
                    <span className="detail-value">{post.first_name + " " + post.last_name || "N/A"}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Created Date</span>
                    <span className="detail-value">{post.createdAt ? new Date(post.createdAt).toLocaleDateString() : "N/A"}</span>
                  </div>
                  {post.amenities && (
                    <div className="detail-item">
                      <span className="detail-label">Amenities</span>
                      <span className="detail-value">{post.amenities}</span>
                    </div>
                  )}
                </>
              )}
              
              {/* Show Interest Button at bottom of details */}
              <div className="show-interest-section">
                <button className="action-btn primary show-interest-btn" onClick={openInterestFlow}>
                  Show Interest
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <>
      <div className="search-page-container">
        <div className="search-content">
          <div className="posts-sidebar">
            <div className="posts-controls">
              <div className="search-box">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search posts..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && searchQuery.trim()) {
                      navigate("/search?query=" + encodeURIComponent(searchQuery.trim()));
                    }
                  }}
                  className="search-input"
                />
              </div>
            </div>

            <div className="category-switcher">
              <button
                className={`category-btn ${selectedCategory === "0" ? "active" : ""}`}
                onClick={() => updateSelectedCategory("0")}
              >
                <FaBorderAll />
                <span>All</span>
              </button>
              <button
                className={`category-btn ${selectedCategory === "1" ? "active" : ""}`}
                onClick={() => updateSelectedCategory("1")}
              >
                <FaHome />
                <span>Houses</span>
              </button>
              <button
                className={`category-btn ${selectedCategory === "2" ? "active" : ""}`}
                onClick={() => updateSelectedCategory("2")}
              >
                <FaBoxes />
                <span>Utility</span>
              </button>
              <button
                className={`category-btn ${selectedCategory === "3" ? "active" : ""}`}
                onClick={() => updateSelectedCategory("3")}
              >
                <FaUsersCog />
                <span>Others</span>
              </button>
            </div>

            

            <div className="posts-list">
              {filteredData?.length === 0 ? (
                <div className="empty-state">
                  <FaImage />
                  <h3>No Results Found</h3>
                  <p>Try a different search term</p>
                </div>
              ) : (
                filteredData?.map((value, idx) => (
                  <React.Fragment key={value.id}>
                    <div
                      className={`post-card ${selectedId === value.id ? "selected" : ""}`}
                      onClick={() => getPost(value.id)}
                    >
                      <div className="post-avatar">
                        {value.images && value.images[0] ? (
                          <img src={value.images[0]} alt="Post" />
                        ) : (
                          <FaImage className="avatar-placeholder" />
                        )}
                      </div>
                      <div className="post-content">
                        <div className="post-title-container">
                          <div className="post-title">{value.title}</div>
                          <div className="post-price">{value.price}</div>
                        </div>
                        <div className="post-actions">
                          <div className="post-location">
                            <FaMapMarkerAlt />
                            {value.location}
                          </div>
                          <div className="post-category">
                            <FaTag />
                            {value.category}
                          </div>
                          <div className="post-date">
                            <FaCalendarAlt />
                            {new Date(value.createdAt).toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                    </div>
                    {idx === 2 && <InFeedAd />}
                  </React.Fragment>
                ))
              )}
            </div>
          </div>

          <div className="post-detail-panel">
            <PostDetail post={postDetail} />
            <InArticleAd />
          </div>
        </div>
      </div>





      {isModalOpen && (
              <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <button className="close-button" onClick={() => setIsModalOpen(false)}>×</button>
                  <div className="main-image-container" onClick={() => setIsModalOpen(true)}>
                    <img src={selectedImage} alt="Selected" className="modal-image" />
                  </div>
                  <div className="modal-images">
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Modal ${index}`}
                        className="modal-thumbnail"
                        onClick={() => {
                          setSelectedImage(img);
                        }}
                      />
                    ))}
                  </div>
                  <div style={{ backgroundColor: "#F0F1F4" }}>
                    {postDetail?.created_date &&
                      (() => {
                        const d = getDetails(postDetail);
                        const utils = Array.isArray(d?.Utilities) ? d.Utilities : [];
                        return (
                          <>
                            {Object.entries(d)
                              .filter(([k]) => k !== "Utilities")
                              .map(([key, value], index) => (
                                <div key={index} className="detailContainer">
                                  <p>{key}</p>
                                  <p>{value ?? "N/A"}</p>
                                </div>
                              ))}
                            {utils.length > 0 && (
                              <div style={{ padding: "8px 12px" }}>
                                <p style={{ fontWeight: 700, margin: "0 0 6px" }}>Utilities</p>
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: 13,
                                  }}
                                >
                                  <thead>
                                    <tr style={{ borderBottom: "1px solid #cbd5e1" }}>
                                      <th style={{ textAlign: "left", padding: "4px 0" }}>Item</th>
                                      <th style={{ textAlign: "left", padding: "4px 0" }}>Price</th>
                                      <th style={{ textAlign: "left", padding: "4px 0" }}>Store</th>
                                      <th style={{ textAlign: "left", padding: "4px 0" }}>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {utils.map((u) => (
                                      <tr key={u.id ?? u.name} style={{ borderBottom: "1px solid #e2e8f0" }}>
                                        <td style={{ padding: "6px 4px 6px 0" }}>{u.name || "—"}</td>
                                        <td style={{ padding: "6px 4px" }}>
                                          {u.price != null && u.price !== ""
                                            ? `$${Number(u.price).toFixed(2)}`
                                            : "—"}
                                        </td>
                                        <td style={{ padding: "6px 4px" }}>
                                          {u.storeLink ? (
                                            <a href={u.storeLink} target="_blank" rel="noopener noreferrer">
                                              Link
                                            </a>
                                          ) : (
                                            "—"
                                          )}
                                        </td>
                                        <td style={{ padding: "6px 0 6px 4px" }}>{u.availabilityStatus || "—"}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </>
                        );
                      })()}
                    <button className="showInterest" style={{ padding: "5px 15px", margin: "0px", height: '40px' }} onClick={() => { openInterestFlow(); setIsModalOpen(false); }}>Show Interest</button>
                  </div>
                </div>
              </div>
            )}
      
      {showModal && <InterestModal selectedPost={postDetail} onClose={() => { setShowModal(false) }} />}
      </>
    )
}

export default SearchScreen;